import { apiFiles } from "@/api/file.api.ts";
import { ApiFile } from "@/types/common.types.ts";
import { useEffect, useState } from "react";

export function useFileObjectUrl(file: ApiFile | null) {
  const [url, setUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(!!file);
  const [isError, setIsError] = useState(false);
  const [syncedFile, setSyncedFile] = useState(file);

  if (file !== syncedFile) {
    setSyncedFile(file);
    if (file) {
      setIsLoading(true);
      setIsError(false);
    } else {
      setUrl(null);
    }
  }

  useEffect(() => {
    if (!file) return;

    let isActive = true;
    let objectUrl: string | null = null;

    void (async () => {
      const { data, error, headers } = await apiFiles.getPrivate(file.uuid);
      if (!isActive) return;

      if (error || !data) {
        setIsError(true);
        setIsLoading(false);
        return;
      }

      const contentType = headers?.["content-type"];
      const blobType = typeof contentType === "string" ? contentType : file.mime_type;
      const blob = data instanceof Blob ? data : new Blob([data], { type: blobType });
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
      setIsLoading(false);
    })();

    return () => {
      isActive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [file]);

  return { url, isLoading, isError };
}
